(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["winter-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){
 const select=event.target.closest('[data-variant-select]'); if(!select)return;
 const section=select.closest('[data-product-section]');const option=select.selectedOptions[0];
 section.querySelector('[data-price]').textContent=option.dataset.price;
 const button=section.querySelector('[data-buy]');const available=button.dataset.launchReady==='true'&&option.dataset.available==='true';
 button.disabled=!available;button.textContent=available?button.dataset.buyLabel:button.dataset.unavailableLabel;
 const image=section.querySelector('.main-image img');if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;}
});

  } catch(e) { console.error(e); }
})();
})();
